import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import paymentsAPI from '../../api/payments';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
    isFetchingPaymentContact: false
  },
  graphData: [],
  ListContactPayment: []
};

export const getters = {
  getPayments(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getLabelsOnSidebar(_state) {
    return _state.records
      .filter(record => record.show_on_sidebar)
      .sort((a, b) => a.title.localeCompare(b.title));
  },
  graphData(_state){
    return _state.graphData;
  },
  ListAllPayment(_state){
    return _state.ListContactPayment;
  }
};

export const actions = {
  makePayment: async ({ commit }, statusObj) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: true });
    try {
      console.log("Hello")
      const response = await paymentsAPI.makepayment(statusObj);
      console.log("Response",response);
      // commit(types.ADD_CAMPAIGN, response.data);
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: false });
    }
  },
  // PaymentFilter: async ({ commit }, statusObj) => {
  //   if(statusObj?.csv==false){
  //       commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: true });
  //     }
  //   try {
  //     console.log("Hello")
  //     const response = await paymentsAPI.paymentfilter(statusObj);
  //     console.log("Response",response);
  //     commit(types.SET_PAYMENT, response.data);
  //     // return response;
  //   } catch (error) {
  //     throw new Error(error);
  //   } finally {
  //     commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: false });
  //   }
  // },


  PaymentFilter: async ({ commit }, statusObj) => {
    const isCSV = statusObj?.csv === true;
  
    if (!isCSV) {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: true });
    }
  
    try {
      const response = await paymentsAPI.paymentfilter(statusObj);
      console.log("My Response",response);
      if (isCSV) {
        const blob = new Blob([response.data], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute(
          'download',
          `payments-${new Date().toISOString().split('T')[0]}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        commit(types.SET_PAYMENT, response.data);
      }
    } catch (error) {
      console.error('PaymentFilter error', error);
      throw new Error(error);
    } finally {
      if (!isCSV) {
        commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: false });
      }
    }
  },
  GraphView:async({ commit }, statusObj) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isFetchingItem: true });
    try {
      console.log("Hello")
      const response = await paymentsAPI.graphview(statusObj);
      console.log("Response",response);
      commit(types.SET_GRAPH, response.data);
      // return response;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetchingItem: false });
    }
  },
  getAllPayment: async ({ commit }) => {
    try {
      console.log("Hiiiiii")
      const response = await paymentsAPI.allpayment();
      console.log("Response",response);
      // commit(types.SET_STATUS, response.data.states_data);
    } catch (err) {
      console.error("Error while Fetching the data", err);
    }
  },
  FetchallAgent: async ({ commit }) => {
    try {
      console.log("Hiiiiii")
      const response = await paymentsAPI.fetchallagent();
      console.log("Response",response);
      commit(types.SET_STATUS, response.data.states_data);
    } catch (err) {
      console.error("Error while Fetching the data", err);
    }
  },
  PaymentCategories: async ({ commit }) => {
    try {
      console.log("Hiiiiii")
      const response = await paymentsAPI.paymentcategories();
      console.log("Response",response);
      commit(types.SET_STATUS, response.data.states_data);
    } catch (err) {
      console.error("Error while Fetching the data", err);
    }
  },
  AllPayment: async ({ commit }) => {
    try {
      console.log("Hiiiiii")
      const response = await paymentsAPI.allpayment();
      console.log("Response",response);
      commit(types.SET_STATUS, response.data.states_data);
    } catch (err) {
      console.error("Error while Fetching the data", err);
    }
  },
  AllPaymentContactList: async ({ commit },data) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isFetchingPaymentContact: true });
    try {
      console.log("Hiiiiii",data);
      const response = await paymentsAPI.allpaymentContactList(data);
      console.log("Response",response);
      commit(types.SET_LIST_CONTACT_PAYMENT, response.data.payments);
      return response;
    } catch (err) {
      console.error("Error while Fetching the data", err);
    }finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetchingPaymentContact: false });
    }
  },
};

export const mutations = {
  [types.SET_CAMPAIGN_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_PAYMENT]: MutationHelpers.set,
  [types.SET_GRAPH]: MutationHelpers.setGraph,
  [types.SET_LIST_CONTACT_PAYMENT]: MutationHelpers.setContactPayment,
  [types.ADD_LABEL]: MutationHelpers.create,
  [types.EDIT_LABEL]: MutationHelpers.update,
  [types.DELETE_LABEL]: MutationHelpers.destroy,
  [types.SET_LABELS_DATA](_state,data){
    _state.labelData=data;
  } 
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
